import { styled } from "@mui/material/styles";
import React, { FunctionComponent } from "react";
import { FlexColumn, LoadingPlaceholder } from "designSystem/index";

const PREFIX = "LoadingMSTeams";

const classes = {
	root: `${PREFIX}root`,
};

const StyledFlexColumn = styled(FlexColumn)({
	[`&.${classes.root}`]: {
		alignItems: "center",
		flex: 1,
		height: "100%",
		justifyContent: "center",
		width: "100%",
	},
});

const LoadingMSTeams: FunctionComponent = () => {
	return (
		<StyledFlexColumn className={classes.root} flexGrow={1}>
			<LoadingPlaceholder
				subtitleProps={{ res: "LoadingMSTeamsSubtitle" }}
				titleProps={{ res: "Loading" }}
			/>
		</StyledFlexColumn>
	);
};
export default LoadingMSTeams;
